/* import __COLOCATED_TEMPLATE__ from './report-list.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { Report } from '../../models/report';

const CLASS_NAME = 'SH-c-admin-reports__report-list';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  api: service(),

  /** @param {Task} */
  loadReports: null,

  /** @param {Ember.A<Report>} */
  reports: null,

  /** @inheritDoc */
  actions: {
    //
  },
});
